import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  text: string;
  subtitle?: string;
  variant?: 'primary' | 'secondary';
}
export function CtaButton({
  text,
  subtitle,
  variant = 'primary'
}: CtaButtonProps) {
  if (variant === 'secondary') {
    return <div className="text-center mt-12" data-id="element-61">
        <motion.a href="#precio" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="border-2 border-amber-gold text-amber-gold font-bold text-base md:text-lg px-10 py-5 rounded-full inline-flex items-center gap-3 hover:bg-amber-gold/10 transition-all" data-id="element-62">
          {text}
          <ArrowRight className="w-5 h-5" strokeWidth={2.5} data-id="element-63" />
        </motion.a>
        {subtitle && <p className="text-warm-cream/50 mt-4 text-sm" data-id="element-64">{subtitle}</p>}
      </div>;
  }
  return <div className="text-center mt-12" data-id="element-65">
      <motion.a href="#precio" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="bg-amber-gold text-dark-navy font-bold text-lg md:text-xl px-12 py-6 rounded-full inline-flex items-center gap-3 shadow-2xl hover:shadow-amber-gold/20 transition-all no-underline" data-id="element-66">
        {text}
        <ArrowRight className="w-6 h-6" strokeWidth={2.5} data-id="element-67" />
      </motion.a>
      {subtitle && <p className="text-warm-cream/50 mt-4 text-sm" data-id="element-68">{subtitle}</p>}
    </div>;
}